import * as React from "react";
import type { SVGProps } from "react";
const SvgCollapse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M9.75 21v-6.75H3M14.25 3v6.75H21"
    />
  </svg>
);
export default SvgCollapse;
